import PromotionPoints from "components/Home/PromotionPoints";

const DoubleUpPromotionDetails = () => {
    return (
      <>
        <p className={`text-navyBlue font-poppins`}>
          Attract new customers by making their rewards worth twice as much when
          they redeem with you!
        </p>
        <PromotionPoints
          heading={"How it works:"}
          points={[
            "When new customers redeem their rewards balance with you, their rewards will be worth twice as much. For example, if they have $10 in their rewards balance, they can redeem it towards a $20 purchase if they shop with you!",
            "Only shoppers who have not made a purchase with your business previously on Open Rewards can qualify. Limited once per person.",
            "The doubled up amount will be deducted from your rewards fund",
          ]}
        />
        
        <PromotionPoints
          heading={"Perks:"}
          points={[
            'Highlighted under the prominent "Double-up" filter on Discovery tab',
            "Announcement in home screen activity feed",
            "Highlighted on Redeem business list",
          ]}
        />
      </>
    );
};

export default DoubleUpPromotionDetails;